import { render, staticRenderFns } from "./employer-dropdown.vue?vue&type=template&id=fcebb68c"
import script from "./employer-dropdown.vue?vue&type=script&lang=js"
export * from "./employer-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports